import { routes } from '../config/routes';
import { SAVE_TAX_SUB_CAT } from './ExplorePage';

export const SWITCH_OR_STP = 'Switch/STP';
export const SWITCH_FROM = 'Switch From';
export const FOLIO_NUMBER = 'Folio Number';
export const NAV = 'NAV';
export const TOTAL_AMOUNT = 'Total Amount';
export const TOTAL_UNITS = 'Total Units';
export const FREE_AMOUNT = 'Free Amount';
export const FREE_UNITS = 'Free Units';
export const SWITCH_TO = 'Switch To';
export const REMOVE = 'Remove';
export const CLEAR_ALL = 'Clear All';
export const PLACEHOLDER = 'Search for a fund to switch from same fund house';
export const OR = 'OR';
export const FUND_CATEGORY = 'Fund Category';
export const SELECT_FOLIO_NUMBER = 'Select Folio Number';
export const SWITCH_IN_SCHEME_OPTION = 'Switch In Scheme Option';
export const GROWTH = 'Growth';
export const DIVIDEND = 'Dividend';
export const IDCW = 'IDCW';
export const IDCW_OPTION = 'IDCW Option';
export const PAYOUT = 'Payout';
export const REINVESTMENT = 'Reinvestment';
export const RE_INVESTMENT = 'Re-Investment';
export const CONTINUE = 'Continue';
export const TYPE_LABEL_NAME = 'Choose your transfer type';
export const ONE_TIME = 'One Time';
export const SYSTEMATIC = 'Systematic Transfer';
export const SELECT_OPTION = 'Select Option';
export const FULL = 'Full Switch';
export const PARTIAL = 'Partial Switch';
export const INVESTMENT_TIME_FRAME = 'Investment Time Frame';
export const IN_YEARS = 'In Years';
export const DESCRIPTION =
  '<b>Note :</b> First systematic transaction will get executed immediately. The number of systematic transactions selected by you will be over and above this transaction, and will get executed in future as per the chosen schedule.';
export const DESCRIPTION_AMOUNT =
  '<b>Note :</b> When you choose Switch or Redeem transaction by Amount, the transaction will be processed basis the cut-off timing and the NAV will be applicable accordingly. There is a possibility that the transaction may get rejected due to the difference in opted amount and current value because of NAV fluctuation.';
export const PROCEED = 'Proceed';
export const CANCEL = 'Cancel';
export const EDIT = 'Edit';
export const INSTALLMENT_FREQUENCY = 'Transfer Frequency';
export const NUMBER_OF_INSTALLMENT = 'Number of Transfers';
export const SCHEDULED_DATE = 'Scheduled Date';
export const SCHEDULED_DATE_DROPDOWN_SUFFIX = 'Starting from 30th of December';
export const RADIO_BUTTONS_LABEL = 'Select option to switch in amount or units';
export const FULL_SWITCH_MESSAGE = '';
export const MINIMUM = 'Minimum';
export const NUMBER_OF_INSTALLMENT_PLACEHOLDER = (value: number) => `Min. ${value}`;
export const UNITS = 'Units';
export const AMOUNT = 'Amount';
export const DETAILS_LABEL = 'Transfer Details';
export const TOOL_TIP_MESSAGE =
  'Investment Timeframe is amount of time over which you plan to hold an investment. This is different for lock-in period. Investment Timeframe is used to suggest if the purchase you’re making is suitable for you.';
export const ELSS = SAVE_TAX_SUB_CAT;
export const CLOSED = 'CLOSED';
export const SAVE_TAX = 'Save Tax';
export const START_SIP = 'Start SIP';
// constant field name
export const ONE_TIME_OR_SYSTEMATIC = 'oneTimeOrSystematic';
export const FULL_OR_PARTIAL = 'fullOrPartial';
export const TERMS_AND_CONDITION = 'Terms & Conditions';
export const INVESTMENT_TIME_FRAME_MAPPING = {
  'less than 3 months': 'T1',
  '3-9 months': 'T2',
  '9-12 months': 'T3',
  '12-18 months': 'T4',
  '18-24 months': 'T5',
  '2-3 years': 'T6',
  'greater than 3 years': 'T7',
};
export const INVESTMENT_TIME_FRAME_MAPPING_FOR_DROPDOWN = {
  T1: 'less than 3 months',
  T2: '3-9 months',
  T3: '9-12 months',
  T4: '12-18 months',
  T5: '18-24 months',
  T6: '2-3 years',
  T7: 'greater than 3 years',
};
// export const NOTE_POINTS = (liquidCutOffTimings: string, othersCutOffTimings: string) => [
//   `The cut-off timing for redemption and switch transactions made through Axis Bank in overnight, liquid & other schemes is ${othersCutOffTimings}. Transactions made post cut-off timings will be processed the next business day. The NAV applicability will vary as per the cut-off timings. `,
//   'Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled.',
// ];
export const NOTE_POINTS = (
  liquidCutOffTimings: string,
  othersCutOffTimings: string,
  liquidSwitch: string,
  overNight?: string
) => [
  `Please note that the cut-off timings for transactions made through Axis Bank is ${liquidSwitch} except for Overnight funds which is ${overNight}. Transaction made post cut-off timings will be processed the next business day. The NAV applicability will vary as per the cut-off timings.`,
  'Please check the information entered before proceeding. Axis Bank will not be liable for any typographical error occurred while entering the details. Deal once entered & processed successfully can not be cancelled.',
];
export const scheduledDates = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
];
export const FUND_CATEGORY_LIST = [
  {
    label: 'Equity Funds',
    value: 'equity',
  },
  {
    label: 'Debt Funds',
    value: 'debt',
  },
  {
    label: 'Hybrid Funds',
    value: 'hybrid',
  },
  {
    label: 'Liquid Funds',
    value: 'liquid',
  },
  {
    label: 'Others',
    value: 'others',
  },
];

export const TIME_FRAME = [
  {
    label: 'less than 3 months',
    value: 'less than 3 months',
  },
  {
    label: '3-9 months',
    value: '3-9 months',
  },
  {
    label: '9-12 months',
    value: '9-12 months',
  },
  {
    label: '12-18 months',
    value: '12-18 months',
  },
  {
    label: '18-24 months',
    value: '18-24 months',
  },
  {
    label: '2-3 years',
    value: '2-3 years',
  },
  {
    label: 'greater than 3 years',
    value: 'greater than 3 years',
  },
];

export const FREQUENCY = [
  {
    label: 'Monthly',
    value: 'Monthly',
  },
];
export const CATEGORY_MAPPING = {
  equity: 'Equity Funds',
  debt: 'Debt Funds',
  hybrid: 'Hybrid Funds',
  liquid: 'Liquid Funds',
  nfo: 'NFOs',
  others: 'Others',
};

export const SCHEME_LABEL_MAPPING = {
  equity: 'Equity Fund Scheme',
  debt: 'Debt Fund Scheme',
  hybrid: 'Hybrid Fund Scheme',
  liquid: 'Liquid Fund Scheme',
  others: 'Other Scheme',
  nfo: 'NFO Scheme',
};

export const ALLOWED_AMC_WITH_MULTIPLE_FOLIO_NUMBER = ['FRANKLIN'];

export const ELSS_OR_CLOSED_FUND = [SAVE_TAX_SUB_CAT, 'CLOSED'];

export const SWITCH_NUDGES_BUTTON_TEXT = [
  { label: 'Explore Investment Ideas', route: routes.INVESTMENT_IDEAS.url },
  { label: 'Plan your goals with a SIP', route: routes.PLAN_SIP.url },
];
